module.exports = __webpack_public_path__ + "img/bg1.a78b696c.jpg";